/** @format */
import { css } from 'styled-components';

const baseStyles = () => {
    return css`
        cursor: pointer;
        padding: 0.4rem;
        margin: -0.4rem;
        border-radius: 1000px;
    `;
};

export const styles = () => css`
    ${baseStyles()}
`;
